import BugReportOutlinedIcon from "@mui/icons-material/BugReportOutlined";

import { RobotoIconButton } from "@/shared/components/RobotoIconButton";
import { RobotoTooltip } from "@/shared/components/RobotoTooltip";

import styles from "./MessageDebugButton.module.css";

interface MessageDebugButtonProps {
  /** Switches the whole thread view to show what Bedrock saw for this message. */
  onActivate: () => void;
}

/**
 * Compact icon button in the message-actions row, beside Fork and Feedback.
 * Pressing it replaces the conversation with the reconstructed Bedrock view
 * for this message (handled by the parent viewer) — it does not expand inline.
 */
export function MessageDebugButton({ onActivate }: MessageDebugButtonProps) {
  const label = "Debug — view what Bedrock saw";
  return (
    <RobotoTooltip title={label}>
      <span>
        <RobotoIconButton
          aria-label={label}
          className={styles.iconButton}
          onClick={onActivate}
        >
          <BugReportOutlinedIcon className={styles.icon} />
        </RobotoIconButton>
      </span>
    </RobotoTooltip>
  );
}
